import React, { useContext, useEffect, useState } from 'react';
import { equals, pick } from 'ramda';
import { AppBar, IconButton, Typography } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { func } from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import * as R from 'ramda';
import { checkStringForDash } from 'utils/helpers/format';
import {
  CreateCustomerAuthContext,
  initialStateStep1,
} from 'feature/loading-management/customer-authorizations/create/Create';

const TitleBar = ({ onClose }) => {
  const [title, setTitle] = useState('Dashboard');

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const authorizationType = pathname.split('/')[5];

  const { info, setOpenDialog, setIsNavHidden } = useContext(CreateCustomerAuthContext);

  const hasCustomerIdName = R.not(R.isNil(R.prop('customerIdName', info)));
  const step = pathname.split('/')[7];
  const isOnStep1 = step.includes('customer-information');

  useEffect(() => {
    if (!hasCustomerIdName && !isOnStep1) {
      navigate('../customer-information');
      navigate(0);
    }
  }, [hasCustomerIdName, isOnStep1, navigate]);

  const handleClose = event => {
    const changeProps = pick([
      'authorizationType',
      'authorizationVolume',
      'customerIdName',
      'renewalVolume',
    ]);
    const contextProps = changeProps(info);
    const initialProps = changeProps(initialStateStep1);
    const hasChanges = !equals(initialProps, contextProps);

    onClose(event, hasChanges, setOpenDialog);

    if (!event.isDefaultPrevented()) {
      if (hasChanges) {
        setOpenDialog(true);
      } else {
        navigate('../../');
        setIsNavHidden(false);
      }
    }
  };

  useEffect(() => {
    const formatted = checkStringForDash(authorizationType);
    const unpluralized = formatted.substring(0, formatted.length - 1);
    setTitle(unpluralized);
  }, [authorizationType]);

  return (
    <AppBar
      elevation={1}
      sx={{
        alignItems: 'center',
        backgroundColor: 'surface.white',
        flexDirection: 'row',
        height: 48,
        justifyContent: 'space-between',
        px: 2,
      }}
    >
      <Typography
        noWrap
        sx={{
          textOverflow: 'ellipsis',
        }}
        variant="h6"
      >
        Create New {title}
      </Typography>
      <IconButton
        onClick={handleClose}
        size="large"
        sx={{
          color: 'graphic.icons',
        }}
      >
        <CloseRoundedIcon />
      </IconButton>
    </AppBar>
  );
};

TitleBar.propTypes = {
  onClose: func,
};
TitleBar.defaultProps = {
  onClose: () => {},
};

export default TitleBar;
